export const RerunIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.51246 19.2076C8.30027 19.4154 7.96034 19.4136 7.75034 19.2036L5.41797 16.8712L7.75035 14.5387C7.96034 14.3287 8.30028 14.3269 8.51247 14.5347C8.72781 14.7455 8.72963 15.0917 8.5165 15.3048L7.49172 16.3296H16.6294V13.6212C16.6294 13.3221 16.8719 13.0796 17.1711 13.0796C17.4702 13.0796 17.7128 13.3221 17.7128 13.6212V16.5461C17.7128 17.0247 17.3248 17.4127 16.8461 17.4127H7.49172L8.51649 18.4375C8.72962 18.6506 8.72781 18.9967 8.51246 19.2076ZM6.83151 10.9191C6.53236 10.9191 6.28984 10.6766 6.28984 10.3775V7.45264C6.28984 6.97402 6.67785 6.58602 7.15647 6.58602H16.5109L15.4861 5.56124C15.273 5.34811 15.2748 5.002 15.4901 4.79111C15.7023 4.58332 16.0423 4.5851 16.2523 4.7951L18.5846 7.12747L16.2523 9.46004C16.0423 9.67005 15.7023 9.67183 15.4901 9.46404C15.2748 9.25315 15.273 8.90705 15.4861 8.69392L16.5109 7.66914H7.37318V10.3775C7.37318 10.6766 7.13066 10.9191 6.83151 10.9191Z'
      fill='currentColor'
    />
  </svg>
)
